import { getUser } from "../actions/auth";
import { showHouseholdCustomId } from "./permissions";

export function descriptiveHouseholdName(household) {
  const client = household.Clients[0];
  const coClient = household.Clients[1];

  if (client === undefined) {
    return `${household.household_name}`;
  }
  if (coClient === undefined) {
    return `${client.first_name.trim()}  ${client.last_name.trim()}`;
  }
  if (client.last_name === coClient.last_name) {
    return `${client.first_name.trim()} and ${coClient.first_name.trim()} ${client.last_name.trim()}`;
  }
  return `${client.first_name.trim()} ${client.last_name.trim()} and ${coClient.first_name.trim()} ${coClient.last_name.trim()}`;
}

function householdCustomIdLabel(customId) {
  if (!showHouseholdCustomId(getUser())) {
    return "";
  }

  return customId ? `HH ID: ${customId}` : "";
}

export function householdOptionLabel(household) {
  const customIdLabel = householdCustomIdLabel(household.custom_id);
  return customIdLabel ? `${household.household_name} (${customIdLabel})` : household.household_name;
}

export const agreementAuditCompleted = (auditDate, agreementFilePath) => {
  if (!auditDate) return false;
  if (!agreementFilePath) return false;
  const uploadDate = extractUploadDate(agreementFilePath);
  if (!uploadDate) return false;
  return auditDate > uploadDate;
};

export const extractUploadDate = (path) => {
  const filepath = typeof path === "string" ? path : path[0].path;
  const m = filepath.match(/-(\d{10,16})\.\w+$/);
  if (!m) return null;
  if (!m[1]) return null;
  return new Date(Number(m[1]));
};
